const Style = ({ attributes, clientId }) => {
	const { members = [], columnGap, rowGap, layout, textAlign, padding, photoWidth, photoMargin, nameTypo, nameMargin, titleTypo, titleMargin, sepMargin, bioTypo, bioMargin, socialSize, socialIconMargin } = attributes;

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${nameTypo?.googleFontLink ? `@import url(${nameTypo?.googleFontLink})` : ''}
			${titleTypo?.googleFontLink ? `@import url(${titleTypo?.googleFontLink})` : ''}
			${bioTypo?.googleFontLink ? `@import url(${bioTypo?.googleFontLink})` : ''}

			#tsbTeamMembers-${clientId} .tsbTeamMembers{
				grid-gap: ${rowGap} ${columnGap};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember{
				text-align: ${textAlign};
				padding: ${padding?.styles || '50px 20px'};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberPhoto{
				width: ${photoWidth};
				margin: ${'horizontal' === layout ? '0 20px 0 0' : `${photoMargin?.styles || '0 0 20px 0'}`};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberName{
				${nameTypo?.styles || 'font-size: 20px; font-weight: 600;'}
				margin: ${nameMargin?.styles || '0 0 10px 0'};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberTitle{
				${titleTypo?.styles || 'font-size: 16px;'}
				margin: ${titleMargin?.styles || '0 0 10px 0'};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSeparator{
				margin: ${sepMargin?.styles || '0 0 15px 0'};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberBio{
				${bioTypo?.styles || 'font-size: 15px;'}
				margin: ${bioMargin?.styles || '0 0 15px 0'};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .icon, #tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .memberSocialAdd{
				margin: ${socialIconMargin?.styles || '10px 10px'};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .icon i, #tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .memberSocialAdd i{
				font-size: ${socialSize};
				width: ${socialSize};
			}
			`.replace(/\s+/g, ' ')
		}} />

		{members.map((item, index) => {
			const { background, border, shadow, photoBorder, nameColor, titleColor, separator, bioColor, socialIconColors } = item;

			return <style key={index} dangerouslySetInnerHTML={{
				__html: `
				#tsbTeamMembers-${clientId} #tsbMember-${index}{
					${background?.styles || 'background-color: #0000;'}
					${border?.styles || 'border-radius: 3px;'}
					box-shadow: ${shadow?.styles || 'none'};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberPhoto{
					${photoBorder?.styles || 'border-radius: 50%;'}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberName{
					color: ${nameColor};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberTitle{
					color: ${titleColor};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberSeparator{
					${separator?.styles || 'width: 20%; border-top: 3px solid #777;'}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberBio{
					color: ${bioColor};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial{
					justify-content: ${'center' === textAlign ? 'center' : 'right' === textAlign ? 'flex-end' : 'flex-start'}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial li a{
					${socialIconColors?.styles || 'color: #fff; background: #4527a4;'}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial li.isSelected{
					border: 2px solid ${socialIconColors?.bg};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial li.memberSocialAdd button i{
					color: ${socialIconColors?.bg};
				}
				`.replace(/\s+/g, ' ')
			}} />;
		})}
	</>;
}
export default Style;